/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsContainerFindingsExecutionPhaseQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsContainerFindingsExecutionPhaseQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsContainerFindingsExecutionPhaseQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsContainerFindingsExecutionPhaseQueryOperator>): AppSecopsContainerFindingsExecutionPhaseQueryOperator {
        let obj = Object.assign(new AppSecopsContainerFindingsExecutionPhaseQueryOperator(), model);
        AppSecopsContainerFindingsExecutionPhaseQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsContainerFindingsExecutionPhaseQueryOperator>): AppSecopsContainerFindingsExecutionPhaseQueryOperator {
        if (!model) return null;
        return AppSecopsContainerFindingsExecutionPhaseQueryOperator.newInstance(<AppSecopsContainerFindingsExecutionPhaseQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsContainerFindingsExecutionPhaseQueryOperator) {
        if (!obj) return;

        models.AppSecopsContainerFindingsExecutionPhaseQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsContainerFindingsExecutionPhaseQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsContainerFindingsExecutionPhaseQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Finding execution phase to include
     */
    execution_phases: Array<models.SecurityFindingsExecutionPhase>;

}
